import React from 'react';
import PropTypes from 'prop-types';
import { useAppConfig } from '@state';

/**
 * Shared presentational shell for the full-screen error/redirect pages
 * (404, study not found, data source connection error). Renders the Radsync
 * logo (when white labeling provides one) above a centered card built from an
 * illustration slab, a divider and a text block.
 */
const ErrorScreen = ({ illustration, title, children }) => {
  const [appConfig] = useAppConfig();
  const logo = appConfig?.whiteLabeling?.createLogoComponentFn?.(React);

  return (
    <div className="bg-background absolute inset-0 flex flex-col items-center justify-center gap-8 p-4">
      {logo && <div className="flex max-h-20 items-center">{logo}</div>}
      <div className="border-input bg-muted flex w-full max-w-md flex-col overflow-hidden rounded-2xl border shadow-lg">
        <div className="bg-background flex items-center justify-center p-8">{illustration}</div>
        <div className="bg-input h-px" />
        <div className="flex flex-col items-center gap-3 p-8 text-center">
          <h1 className="text-foreground text-[22px] font-light">{title}</h1>
          <div className="text-muted-foreground text-[15px] font-light leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorScreen.propTypes = {
  illustration: PropTypes.node,
  title: PropTypes.node,
  children: PropTypes.node,
};

export default ErrorScreen;
